import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router';

import { usePreferences } from '@/react-query/usePreferences';
import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

export const DashboardNavigatorItem = ({
  children,
  dataCy,
  isSelected,
  onClick,
}: {
  children: React.ReactNode;
  dataCy?: string;
  isSelected: boolean;
  onClick: () => void;
}) => {
  return (
    <button
      className={classNames(
        'vai-flex vai-flex-col vai-items-center vai-bg-transparent vai-border-0 vai-py-2 vai-m-0 vai-outline-none focus:vai-ring-0 select-none focus:vai-outline-none active:vai-bg-transparent',
        'vai-cursor-pointer hover:vai-opacity-80',
        isSelected && 'vai-border-b-2 vai-border-sapphire-600',
      )}
      data-cy={dataCy}
      onClick={onClick}
      type="button"
    >
      <span
        className={classNames(
          'vai-text-lg',
          isSelected ? 'vai-text-black' : 'vai-text-zinc-400',
        )}
      >
        {children}
      </span>
    </button>
  );
};

export const DashboardNavigator = ({
  isHygieneDisabled,
}: {
  isHygieneDisabled?: boolean;
}) => {
  const { data: prefs } = usePreferences();
  const { trackEvent } = useTrackEvent();
  const history = useHistory();
  const location = useLocation();

  const canAccessHygieneInsights =
    !!prefs?.enableInsights &&
    prefs?.enableInsights?.length > 0 &&
    prefs?.enableInsights.includes('HYGIENE') &&
    !isHygieneDisabled;

  const handleDashboardChange = (dashboard: 'hygiene' | 'clinical') => {
    const current = location.pathname.includes('clinical')
      ? 'clinical'
      : 'hygiene';
    const insightsRoute = location.pathname.replace(current, dashboard);

    history.push({ pathname: insightsRoute, search: location.search });
    trackEvent(mixpanelEvents.insightsView, {
      dashboard: dashboard.toUpperCase(),
      drilldown: false,
    });
  };

  return (
    <div className="vai-flex vai-flex-col vai-w-full vai-border-b-[1px] vai-border-zinc-200">
      <div className="vai-flex vai-flex-row vai-gap-8">
        <DashboardNavigatorItem
          isSelected={location.pathname.includes('clinical')}
          onClick={() => handleDashboardChange('clinical')}
        >
          Clinical Treatments
        </DashboardNavigatorItem>
        {canAccessHygieneInsights && (
          <DashboardNavigatorItem
            isSelected={location.pathname.includes('hygiene')}
            onClick={() => handleDashboardChange('hygiene')}
          >
            Hygiene Tasks
          </DashboardNavigatorItem>
        )}
      </div>
    </div>
  );
};
